import { isNumber, toNumber, isUndefined } from "lodash";
import { phone } from "phone";
import moment from "moment";
import { ERROR_CODES } from "../constants/device";
import Calculations from "./calculations";

export const formatPhoneNumber = (
  phoneNumberString,
  options = {
    missingMessage: "No Phone #",
    invalidMessage: "Invalid Phone #",
  }
) => {
  if (!phoneNumberString) {
    return options.missingMessage;
  }
  try {
    const isoNumber = phone(phoneNumberString, { country: "" });
    if (!isoNumber.isValid) {
      return options.invalidMessage;
    }

    const formattedNumber = isoNumber.phoneNumber.replace(
      /(\d{1,3})(\d{3})(\d{3})(\d{4})/,
      "$1 ($2) $3-$4"
    );
    return formattedNumber;
  } catch (e) {
    console.log("error", e);
    return options.invalidMessage;
  }
};

export const parsePhoneNumber = (phoneNumberString) => {
  const result = phone(phoneNumberString, { country: "" });
  return result;
};

export const isValidPhoneNumber = (phoneNumberString) => {
  try {
    const result = phone(phoneNumberString, { country: "" });
    return result.isValid;
  } catch (e) {
    return false;
  }
};

export const formatErrorCodes = (errorCode) => {
  if (!errorCode) {
    return "";
  }
  const result = errorCode
    .split(",")
    .filter((code) => ERROR_CODES[toNumber(code)])
    .map((code) => `(${code}) ${ERROR_CODES[toNumber(code)].label}`)
    .join(" | ");
  return result;
};
export const normalizeDevice = (device, { provider }) => {
  const deviceIsOffline =
    device.users &&
    device.users.length &&
    (!device.lastWifiConnection ||
      moment(device.lastWifiConnection).isBefore(
        moment().subtract(12, "hours")
      ));
  const gallonsRemaining = device.lastReadingDistance
    ? Calculations.calculateRemainingGallons(
        { dist: device.lastReadingDistance },
        device
      )
    : null;
  const actualCapacity = Calculations.getActualCapacity(device);
  let refillAmount =
    gallonsRemaining !== null ? actualCapacity - gallonsRemaining : "";
  if (isNumber(refillAmount) && refillAmount < 0) {
    refillAmount = 0;
  }
  const percentRemaining =
    gallonsRemaining !== null
      ? Calculations.calculateRemainingPercent(
          { dist: device.lastReadingDistance },
          device
        )
      : "";

  const deliveryMinimum =
    provider && provider.deliveryMinimum ? provider.deliveryMinimum : 100;
  const deviceMeetsMinimum =
    device.refillAmount >= deliveryMinimum && device.user;
  const deviceBatteryLow =
    !isUndefined(device.lastBattOK) && toNumber(device.lastBattOK) < 80;

  const normalized = {
    ...device,
    gallonsRemaining,
    percentRemaining,
    refillAmount,
    deviceIsOffline,
    deviceMeetsMinimum,
    deviceBatteryLow,
  };
  return normalized;
};
